import AhrefsBatchFetcher from "./AhrefsBatchFetcher";

function App() {
  return <AhrefsBatchFetcher />;
}

export default App;
